import * as React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Header from '../components/header';
import Footer from '../components/footer';

const HEADER_HEIGHT = 50;

const theme = createTheme({
	palette: {
		primary: {
			light: '#D8D7D6',
			main: '#B1282E',
			dark: '#0F1820',
		},
	},
	typography: {
		h5: {
			fontWeight: 50,
			fontSize: 26,
			letterSpacing: 0.5,
		},
	},
	shape: {
		borderRadius: 8,
	},
	mixins: {
		toolbar: {
			height: HEADER_HEIGHT,
		},
	},
	components: {
		MuiDrawer: {
			styleOverrides: {
				paper: {
					backgroundColor: '#0F1820',
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: 'none',
				},
				contained: {
					boxShadow: 'none',
					'&:active': {
						boxShadow: 'none',
					},
				},
			},
		},
	},
});

export default function SharedLayout({ children, showNavigator = false, navigator = null, headerProps = {} }) {
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Header {...headerProps} />
			<Box
				component="div"
				sx={{
					display: 'flex',
					height: `calc(100vh - ${theme.mixins.toolbar.height}px)`,
					width: '100vw',
					overflowX: 'hidden',
				}}
			>
				{showNavigator && navigator}
				<Box
					component="main"
					sx={{
						flex: 1,
						display: 'flex',
						p: 1,
						flexDirection: 'column',
						minWidth: 0,
						bgcolor: '#D8D7D6',
						position: 'relative',
					}}
				>
					<Box
						sx={{
							flex: 1,
							borderRadius: 1,
							bgcolor: '#FFFFFF',
							p: 1,
							boxShadow: 7,
							height: '100%',
							overflowX: 'auto',
							minWidth: 0,
							width: '100%',
							boxSizing: 'border-box',
							position: 'relative',
						}}
					>
						{children}
					</Box>
					<Footer />
				</Box>
			</Box>
		</ThemeProvider>
	);
}
